import Cookies from 'js-cookie';

export default () => ({
	cookieOpen: false,
	personalisedToggle: false,
	analyticsToggle: false,
	cookieSettingsOpen: false,
	cookieConsent: Cookies.get('cookieConsent'),
	cookieToggles: Cookies.get('cookieToggles')
		? JSON.parse(Cookies.get('cookieToggles'))
		: {
				personalisedToggle: false,
				analyticsToggle: false,
		  },
	cookieConsentGroups: Cookies.get('cookieConsentGroups')
		? JSON.parse(Cookies.get('cookieConsentGroups'))
		: {
				adConsentGranted: false,
				adUserDataConsentGranted: false,
				adPersonalizationConsentGranted: false,
				analyticsConsentGranted: false,
				functionalityConsentGranted: true,
				personalizationConsentGranted: false,
				securityConsentGranted: true,
		  },
	init() {
		this.personalisedToggle = this.cookieToggles.personalisedToggle;
		this.analyticsToggle = this.cookieToggles.analyticsToggle;

		const footer = document.querySelector('footer');
		this.setVisible(footer, 30);
		window.addEventListener('scroll', (e) => {
			this.setVisible(footer, 30);
		});

		this.checkLoad();
		this.sendDataLayer();
	},
	saveClose() {
		this.cookieOpen = false;
		setTimeout(() => {
			this.cookieSettingsOpen = false;
		}, 500);
		this.cookieConsent = 1;
		Cookies.set('cookieConsent', '1', { expires: 365, domain: 'grundon.com' });
		Cookies.set(
			'cookieToggles',
			JSON.stringify({
				personalisedToggle: this.personalisedToggle,
				analyticsToggle: this.analyticsToggle,
			}),
			{
				expires: 365,
				domain: 'grundon.com',
			}
		);
		this.sendDataLayer();
	},
	acceptAll() {
		this.personalisedToggle = true;
		this.analyticsToggle = true;
		this.saveClose();
	},
	rejectAll() {
		this.personalisedToggle = false;
		this.analyticsToggle = false;
		this.saveClose();
	},
	setVisible(footer, threshold) {
		const check = this.checkVisible(footer, threshold);
		if (check && !this.cookieInFooter) {
			this.cookieInFooter = true;
		}
		if (!check) {
			this.cookieInFooter = false;
		}
	},
	checkVisible(elm, threshold, mode) {
		threshold = threshold || 0;
		mode = mode || 'visible';

		var rect = elm.getBoundingClientRect();
		var viewHeight = Math.max(
			document.documentElement.clientHeight,
			window.innerHeight
		);
		var above = rect.bottom - threshold < 0;
		var below = rect.top - viewHeight + threshold >= 0;

		return mode === 'above'
			? above
			: mode === 'below'
			? below
			: !above && !below;
	},
	sendDataLayer() {
		let data = {};

		this.cookieConsentGroups = {
			adConsentGranted: false,
			adPersonalizationConsentGranted: false,
			adUserDataConsentGranted: false,
			analyticsConsentGranted: false,
			functionalityConsentGranted: true,
			personalizationConsentGranted: false,
			securityConsentGranted: true,
		};

		let consent = 'denied';
		if (this.personalisedToggle) {
			consent = 'granted';

			this.cookieConsentGroups.adConsentGranted = true;
			this.cookieConsentGroups.adPersonalizationConsentGranted = true;
			this.cookieConsentGroups.adUserDataConsentGranted = true;
			this.cookieConsentGroups.personalizationConsentGranted = true;
		}

		data.ad_storage = consent;
		data.ad_user_data = consent;
		data.ad_personalization = consent;
		data.personalization_storage = consent;

		consent = 'denied';
		if (this.analyticsToggle) {
			consent = 'granted';
			this.cookieConsentGroups.analyticsConsentGranted = true;
		}
		data.analytics_storage = consent;

		window.gtag('consent', 'update', data);

		Cookies.set(
			'cookieConsentGroups',
			JSON.stringify(this.cookieConsentGroups),
			{
				expires: 365,
				domain: 'grundon.com',
			}
		);

		window.dataLayer.push({
			event: 'CookieConsentGroupsUpdated',
			analyticsConsentGranted: this.analyticsToggle ? 1 : 0,
			personalizationConsentGranted: this.personalisedToggle ? 1 : 0,
		});
	},
	checkLoad() {
		if (this.cookieConsent == undefined || this.cookieConsent == null) {
			this.cookieOpen = true;
		}
	},
});
